import React from 'react';
import * as Card from '../../../../v2BaseComponents/Card';
import { APITypes } from '../../../../../primary-record-types';
import _truncate from 'lodash/truncate';
import SearchResultImageDisplay from './SearchResultImageDisplay';
import SearchResultAudioDisplay from './SearchResultAudioDisplay';
import { getIntl } from '../../../../../utils/intl';

const intl = getIntl('SearchResultCard', {
    root: 'Home',
});

export type SearchResultCardOwnProps = {
    medicalProfileId: string;
    searchResult: APITypes.medicalProfileFilesService.MedicalProfileFileSearchItem;
    onPress: () => void;
};

export type SearchResultCardProps = SearchResultCardOwnProps;

const SearchResultCard: React.FC<SearchResultCardProps> = ({ onPress, searchResult, medicalProfileId }) => {
    const getFilePath = () => {
        return [
            intl('root'),
            ...searchResult.fullFolderPath.map((folder) => folder.folderName),
            searchResult.fileName,
        ].join('/');
    };

    return (
        <Card.Card onPress={onPress}>
            <Card.CardContent>
                <Card.CardListHeader>{getFilePath()}</Card.CardListHeader>
                {searchResult.type === 'image' ? (
                    <SearchResultImageDisplay
                        medicalProfileId={medicalProfileId}
                        imageSearchResult={searchResult}
                        showDetailedResult
                    />
                ) : (
                    <SearchResultAudioDisplay
                        medicalProfileId={medicalProfileId}
                        audioSearchResult={searchResult}
                        showDetailedResult
                    />
                )}
                <Card.CardCaption>
                    {_truncate(searchResult.text, {
                        length: searchResult.type === 'image' ? 100 : 400,
                    })}
                </Card.CardCaption>
            </Card.CardContent>
        </Card.Card>
    );
};

export default React.memo(SearchResultCard);
